(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fisioexpo-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('akon-fisioexpo')) {
    class AkonFisioexpo extends HTMLElement {
      connectedCallback() {
        if (this.onSubmit) return;
        this.form = this.querySelector('form');
        this.fields = this.querySelector('[data-fields]');
        this.button = this.querySelector('[type="submit"]');
        this.buttonLabel = this.querySelector('[data-button-label]');
        this.originalLabel = this.buttonLabel.textContent;
        this.errorMessage = this.querySelector('[data-error-message]');
        this.onSubmit = this.submit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
        const ready = this.isReady();
        this.fields.disabled = !ready;
        this.button.disabled = !ready;
        this.querySelector('[data-unavailable]').hidden = ready;
      }

      disconnectedCallback() {
        this.requestController?.abort();
        this.form?.removeEventListener('submit', this.onSubmit);
        this.onSubmit = null;
      }

      isReady() {
        const validId = /^[A-Za-z0-9]{6,16}$/;
        return this.dataset.enabled === 'true' &&
          validId.test(this.dataset.companyId?.trim() || '') &&
          validId.test(this.dataset.listId?.trim() || '');
      }

      showError(message) {
        this.errorMessage.textContent = message;
        this.errorMessage.hidden = false;
        this.errorMessage.focus();
      }

      buildPayload() {
        const instagram = this.form.elements.namedItem('instagram').value.trim().replace(/^@/, '');
        const properties = {
          fisioexpo_campaign: 'FISIOEXPO26',
          fisioexpo_instagram_declared: true,
          fisioexpo_consent_version: '2026-08-28',
          fisioexpo_consent_text: this.dataset.consentText || ''
        };
        if (instagram) properties.fisioexpo_instagram_username = instagram;
        return {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'FISIOEXPO26',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.form.elements.namedItem('email').value.trim(),
                    properties,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: this.dataset.listId.trim() } } }
          }
        };
      }

      async submit(event) {
        event.preventDefault();
        if (this.busy || this.accepted || !this.isReady()) return;
        if (!this.form.reportValidity()) return;
        if (!this.form.elements.namedItem('instagram_follow').checked || !this.form.elements.namedItem('email_consent').checked) return;
        this.errorMessage.hidden = true;
        if (this.form.elements.namedItem('company_website').value.trim()) {
          this.showError(this.dataset.error);
          return;
        }
        const payload = this.buildPayload();
        this.busy = true;
        this.fields.disabled = true;
        this.button.disabled = true;
        this.buttonLabel.textContent = this.dataset.loading;
        this.form.setAttribute('aria-busy', 'true');
        this.requestController = new AbortController();
        const timeout = setTimeout(() => this.requestController.abort(), 15000);
        try {
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.dataset.companyId.trim())}`, {
            method: 'POST',
            credentials: 'omit',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              Accept: 'application/vnd.api+json',
              revision: '2026-07-15'
            },
            body: JSON.stringify(payload),
            signal: this.requestController.signal
          });
          if (response.status !== 202) {
            throw new Error(response.status === 429 ? this.dataset.rateError : this.dataset.error);
          }
          this.accepted = true;
          if (!this.isConnected) return;
          this.querySelector('[data-registration]').hidden = true;
          this.querySelector('[data-success]').hidden = false;
          this.querySelector('[data-success-heading]').focus();
          this.form.reset();
        } catch (error) {
          if (this.isConnected) this.showError(error.name === 'AbortError' ? this.dataset.timeoutError : error.message === this.dataset.rateError ? this.dataset.rateError : this.dataset.error);
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.form.removeAttribute('aria-busy');
          if (!this.accepted) {
            this.fields.disabled = !this.isReady();
            this.button.disabled = !this.isReady();
            this.buttonLabel.textContent = this.originalLabel;
          }
        }
      }
    }
    customElements.define('akon-fisioexpo', AkonFisioexpo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
